<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>申请管理</el-breadcrumb-item>
      <el-breadcrumb-item>身份证绑定申请</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图 -->


    <el-card >
      <el-alert
        title="用于身份证Excel模式上传,具体使用方式咨询客服"
        type="warning"
        center
        show-icon>
      </el-alert>

    </el-card>


    <el-card>
      <!-- 搜索筛选区域 -->
      <el-form :model="queryInfo" :inline="true" class="search-form">
        <el-form-item label="审核状态">
          <el-select v-model="queryInfo.examineStatus" placeholder="请选择状态" clearable style="width: 150px">
            <el-option
              v-for="item in examineStatusList"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="姓名">
          <el-input placeholder="请输入姓名" v-model="queryInfo.userName" clearable style="width: 150px"></el-input>
        </el-form-item>

        <el-form-item label="手机号">
          <el-input placeholder="请输入手机号" v-model="queryInfo.phone" clearable style="width: 180px">
            <el-button slot="append" icon="el-icon-search" @click="getUserList">查询</el-button>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-check" @click="bathApproval()">审批批量通过</el-button>
          <el-button type="success" icon="el-icon-download" @click="exportExcel">导出名单</el-button>
        </el-form-item>
      </el-form>

      <!-- 自动审核开关区域 -->
      <div class="auto-audit-switch">
        <span class="switch-label">审核模式：</span>
        <el-switch
          v-model="autoIdCard"
          active-text="自动审核"
          inactive-text="手动审核"
          :active-value="1"
          :inactive-value="0"
          @change="autoIdCardChange">
        </el-switch>
      </div>

      <!-- 快捷企业绑定二维码 -->
      <div class="qrcode-section">
        <span class="qrcode-label">获取快捷企业绑定二维码:</span>
        <el-button type="text" class="qrcode-view-btn" @click="getBindQrCode">(查看)</el-button>
      </div>
      <!-- 用户列表区域 -->
      <el-table :data="userlist"  @selection-change="handleSelectionChange" border stripe>
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column type="index" width="70" label="序号"></el-table-column>
        <el-table-column prop="userName" label="姓名"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column prop="examineStatus" label="状态"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="examineTime" label="审批时间"></el-table-column>
<!--        <el-table-column  label="状态">-->
<!--          <template slot-scope="scope">-->
<!--            <el-switch-->
<!--              v-model="scope.row.mg_state" @change="userStateChanged(scope.row)">-->
<!--            </el-switch>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column  label="操作" width="200px" fixed="right">
           <template slot-scope="scope">
             <div class="action-buttons">
               <el-button type="success" icon="el-icon-check" size="small" @click="approval([scope.row.identityCardApplyId],1)">通过</el-button>
               <el-button type="danger" icon="el-icon-close" size="small" @click="approval([scope.row.identityCardApplyId],2)">拒绝</el-button>
               <el-button type="warning" icon="el-icon-delete" size="small" @click="deleteIdentityCardApply(scope.row.identityCardApplyId)">删除</el-button>
             </div>
           </template>
        </el-table-column>
      </el-table>

      <!-- 二维码对话框 -->
      <el-dialog
        title="快捷企业绑定二维码"
        :visible.sync="qrCodeDialogVisible"
        width="400px"
        center>
        <div class="qrcode-dialog-content">
          <el-image
            v-if="qrCodeImage"
            :src="qrCodeImage"
            fit="contain"
            style="width: 100%; max-width: 350px;">
            <div slot="placeholder" class="image-placeholder">
              <i class="el-icon-loading"></i>
              <span>加载中...</span>
            </div>
            <div slot="error" class="image-error">
              <i class="el-icon-picture-outline"></i>
              <span>二维码加载失败</span>
            </div>
          </el-image>
          <div v-else class="image-placeholder">
            <i class="el-icon-loading"></i>
            <span>加载中...</span>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="qrCodeDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

    <!-- 分页区域 -->
     <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[20]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        <!-- 添加用户对话框 -->
    </el-card>
 </div>
</template>

<script>
export default {
  data () {
     // 自定义邮箱规则
        var checkEmail = (rule, value, callback) => {
          const regEmail = /^\w+@\w+(\.\w+)+$/
          if (regEmail.test(value)) {
            // 合法邮箱
            return callback()
          }
           // 返回一个错误提示
          callback(new Error('请输入合法邮箱'))
        }
        // 自定义手机号规则
        var checkMobile = (rule, value, callback) => {
          const regMobile = /^1[34578]\d{9}$/
          if (regMobile.test(value)) {
            return callback()
          }
          // 返回一个错误提示
          callback(new Error('请输入合法的手机号码'))
        }
    return {
      //获取用户列表的参数对象
      queryInfo: {
        phone: '',
        userName:'',
        //当前的页数
        page: 1,
        //当前每页显示多少条数据
        limit: 20,
        examineStatus:-1
      },
      userlist: [],
      total: 0,
      multipleSelection:[],
      autoIdCard: 0,
      qrCodeDialogVisible: false,
      qrCodeImage: '',
      examineStatusList:[
        {
          type:-1,
          name:'全部'
        },
        {
          type:0,
          name:'未审核'
        },
        {
          type:1,
          name:'审核通过'
        },
        {
          type:2,
          name:'审核拒绝'
        },
      ]
      }
  },
  created () {
    this.getCompanyConfig()
    this.getUserList()
  },
  methods: {
    async getCompanyConfig() {
      const { data: res } = await this.$http.post('company/queryCompanyData', {})
      if (res.code === '10000') {
        this.autoIdCard = res.data.autoIdCard || 0
      }
    },
    async getUserList() {
      const {data: res} = await this.$http.get('identityCardApply/selectIdentityCardApplyListV2', {
        params: this.queryInfo,
      })   //get参数用params获得
      if (res.code !== '10000') {
        return this.$message.error(res.msg)
      }
      this.userlist = res.data.list;
      this.total = res.data.count
    },
    // 监听pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.limit = newSize
      this.getUserList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page = newPage
      this.getUserList()
    },
    //根据id删除对应信息
    bathApproval: async function () {
      const confirmResult = await this.$confirm(            //promise  用await
        '是否确认审批?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      // 点击确定 返回值为：confirm
      // 点击取消 返回值为： cancel
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消')
      }

      let list = this.multipleSelection;
      let ids = [];
      list.forEach(function(value, key, arr) {
        ids.push(value.identityCardApplyId);
      });

      if(ids.length == 0){
        return this.$message.info('未选中审批内容');
      }
      var param = {};
      param.ids = ids;
      param.examineStatus = 1;

      const {data: res} = await this.$http.post('/identityCardApply/examineIdentityCardApplyV2',param)

      if (res.code !== '10000') return this.$message.error('审批失败！')
      this.$message.success('审批成功！')
      this.getUserList()
    },
    async exportExcel(){
      const {data: res} = await this.$http.get('/identityCardApply/export')
      if (res.code !== '10000') return this.$message.error(res.msg)

      window.location.href= res.data.url;
      this.$message.success('导出成功！')
    },
    async approval(id, type) {
      var param = {};
      param.ids = id;
      param.examineStatus = type;
      const {data: res} = await this.$http.post('/identityCardApply/examineIdentityCardApplyV2',param)

      if (res.code !== '10000') return this.$message.error('审批失败！')
      this.$message.success('审批成功！')
      this.getUserList()

    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async autoIdCardChange(val) {
      const param = { autoIdCard: val };
      const {data: res} = await this.$http.post('/identityCardApply/autoIdCardStatus', param);
      if (res.code !== '10000') {
        this.$message.error(res.msg || '设置失败');
        // 如果接口调用失败，恢复原来的状态
        this.autoIdCard = val === 1 ? 0 : 1;
      } else {
        this.$message.success('设置成功');
      }
    },
    async getBindQrCode() {
      this.qrCodeDialogVisible = true;
      this.qrCodeImage = '';
      try {
        const {data: res} = await this.$http.get('/identityCardApply/getIDCardBindQrCode');
        console.log(res);
        if (res.code === '10000') {
          this.qrCodeImage = res.data.image;
        } else {
          this.$message.error(res.msg || '获取二维码失败');
        }
      } catch (error) {
        this.$message.error('获取二维码失败');
      }
    },
    async deleteIdentityCardApply(id){

      var param = {};
      param.identityCardApplyId = id;

      const confirmResult = await this.$confirm(
        '此操作将删除该数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(error => error)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      } else {
        const {data: res} = await this.$http.post('/identityCardApply/delete',param)
        if (res.code !== '10000') return this.$message.error('删除失败！')
        this.$message.success('删除成功！')
        this.getUserList()
      }


    }

  }
}

</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

// 面包屑导航 - 简约风格
.el-breadcrumb {
  margin-bottom: 24px;
  font-size: 14px;
  color: #909399;
}

// 卡片样式 - 去除多余阴影
.el-card {
  margin-bottom: 20px;
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  &:first-child {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;

    .el-alert {
      background: transparent;
      border: none;
      color: #fff;

      &::v-deep .el-alert__title {
        color: #fff;
        font-size: 15px;
      }

      &::v-deep .el-icon-warning {
        color: #fff;
        font-size: 18px;
      }
    }
  }

  &:last-child {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
  }
}

// 搜索表单 - 现代简约
.search-form {
  margin: 0 0 24px 0;
  padding: 20px 24px;
  background: #fafbfc;
  border-radius: 8px;

  .el-form-item {
    margin-bottom: 0;
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }

  .el-input__inner {
    border-radius: 6px;
    border: 1px solid #e4e7ed;
    font-size: 14px;

    &:focus {
      border-color: #667eea;
    }
  }

  .el-button {
    border-radius: 6px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
  }
}

// 自动审核开关 - 极简设计
.auto-audit-switch {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(to right, #f8f9fa, #ffffff);
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid #e9ecef;

  .switch-label {
    font-size: 15px;
    color: #2c3e50;
    font-weight: 500;
    margin-right: 20px;
    letter-spacing: 0.3px;
  }

  .el-switch {
    margin: 0;
  }
}

// 二维码区域 - 清新设计
.qrcode-section {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  border-radius: 8px;
  margin-bottom: 24px;
  border: none;

  .qrcode-label {
    font-size: 15px;
    color: #37474f;
    margin-right: 12px;
    font-weight: 500;
  }

  .qrcode-view-btn {
    font-size: 15px;
    color: #667eea;
    padding: 0;
    font-weight: 600;

    &:hover {
      color: #764ba2;
    }
  }
}

// 表格样式 - 现代极简
.el-table {
  margin-top: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e7ed;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {
    th {
      background: #f5f7fa;
      color: #606266;
      font-weight: 600;
      font-size: 13px;
      border-bottom: 2px solid #e4e7ed;
    }
  }

  .el-table__body-wrapper {
    td {
      border-bottom: 1px solid #f0f0f0;
    }
  }

  .action-buttons {
    display: flex;
    gap: 8px;

    .el-button {
      border-radius: 4px;
      font-size: 12px;
      padding: 6px 12px;
      font-weight: 500;

      &.el-button--small {
        padding: 6px 12px;
      }
    }
  }
}

// 分页样式 - 简洁
.el-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  padding: 20px 0;

  button {
    border-radius: 6px;
    min-width: 32px;
    height: 32px;
  }

  .el-pager li {
    border-radius: 6px;
    min-width: 32px;
    height: 32px;
    line-height: 30px;

    &.active {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
    }
  }
}

// 二维码对话框 - 现代设计
.qrcode-dialog-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 380px;
  padding: 32px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  border-radius: 12px;

  .el-image {
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .image-placeholder,
  .image-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 14px;

    i {
      font-size: 48px;
      margin-bottom: 12px;
      opacity: 0.6;
    }

    span {
      font-size: 14px;
      font-weight: 500;
    }
  }
}

// 对话框样式优化
::v-deep .el-dialog {
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 24px;

    .el-dialog__title {
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }

    .el-dialog__headerbtn {
      top: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 18px;
      }
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #e4e7ed;

    .el-button {
      border-radius: 6px;
      padding: 10px 24px;
      font-weight: 500;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apply/IdentityCardApply.vue